<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!--      <div class="col-xl-3">-->
      <!--        <BranchStatsPanel />-->
      <!--      </div>-->
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Cash Deposit Checkers Queue</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <CashDepositCheckersQueueTable />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
/**
 * Update Branch Status
 */


import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";
import CashDepositCheckersQueueTable from "../../components/Kleyton/Tables/FundsTransfer/CashDepositCheckersQueueTable";

export default {
  page: {
    title: "Cash Deposit Checkers Queue",
    meta: [
      { name: "Cash Deposit Checkers Queue", content: window.__env.app.description }
    ]
  },
  components: {
    Layout,
    PageHeader,
    CashDepositCheckersQueueTable
  },
  data() {
    return {
      title: "Cash Deposit Checkers Queue",
      items: [
        {
          text: "Cash Deposit",
          href: "/"
        },
        {
          text: "Cash Deposit Checkers Queue",
          active: true
        }
      ]
    };
  }
};
</script>
